import { parseBillingDocumentScope } from '../Invoice/billingDocumentScope';

export const billingWorkspaceSections = [
  { id: 'billing', code: '02-06', label: 'รอบบิล / รับชำระ / รายงาน', path: '/sales/billing' },
  { id: 'pdf', code: '02-11', label: 'PDF วางบิล', path: '/sales/billing-center/pdf' },
  { id: 'email', code: '02-05', label: 'ส่งเอกสาร', path: '/sales/billing-center/email' },
  { id: 'tax', code: '02-04', label: 'ยืนยัน Invoice / e-Tax', path: '/sales/invoice-list' },
  { id: 'tax-pdf', code: '02-10', label: 'รับ PDF จาก Netbay', path: '/sales/netbay-pdf-upload' },
] as const;

export const canReadBillingSection = (permissions: Array<{ roles_code?: string; read?: number; roles_active?: number }>, code: string) =>
  permissions.some(permission => permission.roles_code === code && permission.read === 1 && permission.roles_active !== 0);

export function billingWorkspaceSection(path: string) {
  if (path === '/sales/billing-center/pdf') return 'pdf';
  if (path === '/sales/billing-center/email') return 'email';
  if (path === '/sales/netbay-pdf-upload') return 'tax-pdf';
  if (path === '/sales/invoice-list' || path === '/sales/invoice-detail') return 'tax';
  return 'billing';
}

export function billingWorkspaceHref(id: typeof billingWorkspaceSections[number]['id'], search: string): string {
  const section = billingWorkspaceSections.find(item => item.id === id)!;
  // Tax work includes confirmed invoices which may not belong to a delivered billing round.
  if (id === 'tax' || id === 'tax-pdf') return section.path;
  const source = new URLSearchParams(search);
  const params = new URLSearchParams();
  ['start_date', 'end_date'].forEach(key => { if (source.has(key)) params.set(key, source.get(key)!); });
  const codes = source.getAll('customer_code');
  if (!codes.length && source.has('customerNo')) codes.push(source.get('customerNo')!);
  codes.forEach(code => params.append('customer_code', code));
  const scope = parseBillingDocumentScope(params.toString());
  if (id === 'billing') {
    if (scope.scoped && !scope.invalid && scope.customer_codes.length === 1) {
      params.delete('customer_code');
      params.set('customerNo', scope.customer_codes[0]);
      return `/sales/billing-company-invoices?${params}`;
    }
    return section.path;
  }
  // Preserve malformed scope as well: the destination must show an error, not widen to all customers.
  if (scope.scoped) {
    params.set('date_basis', 'invoice_date');
    return `${section.path}?${params}`;
  }
  return section.path;
}

export function billingPdfSelectionUrl(numbers: string[]): string {
  const params = new URLSearchParams({ date_basis: 'invoice_date' });
  Array.from(new Set(numbers)).forEach(number => params.append('invoice_number', number));
  return `/sales/billing-center/pdf?${params}`;
}
